<template>
  <div class="towPage">
    <div class="small_headline">项目品类: {{ itemClass }}</div>
    <div class="headline">选择门店</div>
    <div class="scheme_class">
      <el-button type="primary" size="small">添加门店</el-button>
      <el-button size="small">删除门店</el-button>
    </div>
    <template>
      <div class="tables">
        <template>
          <el-table :data="tableData" style="width: 100%">
            <el-table-column prop="date" label="门店名称" min-width="180"></el-table-column>
            <el-table-column prop="name" label="门店图" min-width="180"></el-table-column>
            <el-table-column prop="name" label="所在地" min-width="180"></el-table-column>
            <el-table-column prop="name" label="门店地址" min-width="180"></el-table-column>
            <el-table-column prop="name" label="编辑" min-width="180"></el-table-column>
          </el-table>
        </template>
      </div>
    </template>
    <div class="headline">商家介绍（非必填）</div>
    <el-input
      type="textarea"
      :rows="2"
      placeholder="请输入内容"
      v-model="textarea">
    </el-input>
  </div>
</template>

<script>
export default {
  props: ["itemClass"],
  data() {
    return {
      textarea: "",
      tableData: []
    };
  },
  mounted() {
    console.log(this.itemClass);
  }
};
</script>

<style lang="scss" scoped>
.towPage {
  .headline {
    margin: 20px 0px;
    font-size: 16px;
    font-weight: 600;
  }
  .small_headline {
    font-size: 14px;
    margin: 15px 0;
  }
  .scheme_class,
  .newClass {
    margin-top: 15px;
  }
  .tables {
    margin-top: 15px;
    width: 100%;
    border: 1px solid #ebeef5;
  }
}
</style>

<style lang="scss">
.towPage {
  .cell {
    text-align: center;
  }
}
</style>
